module.exports = "<div class=\"terraineditor\">\n  <app-map class=\"map\"></app-map>\n  <app-panel class=\"panel\"></app-panel>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/terraineditor/terraineditor.component.html
// module id = ./src/app/terraineditor/terraineditor.component.html
// module chunks = main